import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import BlockContainer from "../components/BlockContainer";
import { TextForm } from "../components/FormItem";
import { ICON_LOGIN_REGISTER, ICON_LOGIN_SIGNIN } from "../components/icons";
import { PageContext, PAGE_LOGIN } from "../contexts/PageContext";
import { CreateNewUser, AddNewUser } from "../databases/users";

const PageRegister = () => {

    const [regisData, setRegisData] = useState({ email : '', password : '', con : '' })
    const [acceptPDPA, setAcceptPDPA] = useState(false)
    const [onLoading, setOnLoading] = useState(false)

    const { setPage } = useContext(PageContext)

    useEffect(() => {
        return () => {
            setRegisData({ email : '', password : '', con : '' })
            setAcceptPDPA(false)
            setOnLoading(false)
        }
    }, [])

    const onCreateAccout = async () => {
        const { password, con, email } = regisData
        try {
            if (password.length < 6 || password.length > 20) {
                alert('โปรดตั้งรหัสผ่าน 6-20 ตัวอักษร') 
            }
            else if (con !== password) {
                alert('รหัสผ่านไม่ตรงกัน') 
            }
            else {
                setOnLoading(true)
                const user = await CreateNewUser(email, password)
                await AddNewUser(user.uid, email)
            }
        }
        catch (e) {
            console.log(e.message)
        }
        finally {
            setOnLoading(false)
        }
        
    }

    return (
        <BlockContainer>
            <div className="h5 bold text-center">สร้างบัญชีแดนมังกร</div>
            <br />
            <div className="text-danger">เที่ยวบินเหมาลำ รอบ 1 - 6 ไม่ต้องกดสร้างบัญชี ท่านมีบัญชีอยู่แล้ว</div>
            <TextForm title='อีเมล **ใช้สร้างบัญชี โปรดกรอกให้ถูกต้อง แก้ไขไม่ได้!**' value={regisData.email} onChange={e => setRegisData(m => ({...m, email : e.target.value}))}  />                    
            <TextForm type='password' title='รหัสผ่าน' value={regisData.password} onChange={e => setRegisData(m => ({...m, password : e.target.value}))} />
            <TextForm type='password' title='ยืนยันรหัสผ่าน' value={regisData.con} onChange={e => setRegisData(m => ({...m, con : e.target.value}))} />
            <Form.Check 
                checked={acceptPDPA} label={<div>ข้าพเจ้ายอมรับ<a href='./pdf/นโยบายการคุ้มครองข้อมูลส่วนบุคคล.pdf'>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a> (Privacy Policy)</div>} name={`form-check-pdpa3`} id={`form-check-pdpa3`}
                onChange={e => setAcceptPDPA(e.target.checked)} 
            />
            <br />
            <Row bsPrefix="row text-center">
                <Col><Button variant="danger" onClick={() => setPage(PAGE_LOGIN)}>{ICON_LOGIN_SIGNIN} กลับ</Button></Col>
                <Col>
                    <Button disabled={!acceptPDPA || onLoading} onClick={onCreateAccout}>{<Spinner animation="border" hidden={!onLoading} size='sm'/>} <span hidden={onLoading}>{ICON_LOGIN_REGISTER}</span> สร้างบัญชี </Button>
                </Col>
            </Row>
            
        </BlockContainer>
    )
}

export default PageRegister;